import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Menu, Search, Bell, User } from 'lucide-react';

const Header = ({ onMenuClick }) => {
    const { user } = useAuth();

    const [globalSearch, setGlobalSearch] = React.useState('');
    const navigate = useNavigate();

    const handleGlobalSearch = (e) => {
        if (e.key === 'Enter' && globalSearch.trim()) {
            navigate(`/search?keyword=${encodeURIComponent(globalSearch.trim())}`);
            setGlobalSearch(''); // Optional: clear after search
        }
    };

    return (
        <header className="header">
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1 }}>
                <button className="btn btn-ghost mobile-menu-btn" onClick={onMenuClick}>
                    <Menu size={24} />
                </button>
                <div style={{ position: 'relative', maxWidth: '400px', width: '100%' }}>
                    <Search size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'hsl(var(--foreground))', opacity: 0.5 }} />
                    <input
                        type="text"
                        placeholder="Buscar procesos (Global)..."
                        value={globalSearch}
                        onChange={(e) => setGlobalSearch(e.target.value)}
                        onKeyDown={handleGlobalSearch}
                        style={{
                            width: '100%',
                            padding: '0.5rem 1rem 0.5rem 2.5rem',
                            borderRadius: 'var(--radius)',
                            border: '1px solid hsl(var(--border))',
                            background: 'rgba(255,255,255,0.5)',
                            outline: 'none'
                        }}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <button className="btn btn-ghost" style={{ padding: '0.5rem', borderRadius: '50%' }}>
                    <Bell size={20} />
                </button>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', paddingLeft: '1rem', borderLeft: '1px solid hsl(var(--border))' }}>
                    <div className="user-info" style={{ textAlign: 'right' }}>
                        <p style={{ fontSize: '0.875rem', fontWeight: '600' }}>{user?.email?.split('@')[0] || 'Usuario'}</p>
                        <p style={{ fontSize: '0.75rem', opacity: 0.7 }}>Plan Premium</p>
                    </div>
                    <div style={{ width: '40px', height: '40px', background: 'hsl(var(--primary))', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', overflow: 'hidden' }}>
                        {user?.photoURL ? (
                            <img src={user.photoURL} alt="User" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                            <User size={20} />
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
